import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Teaching(props) {
  const topList = [
    {
      name: "个性定制，多元升学",
      desc: "个性化定制学习计划，本科、艺术类院校、对口高职、升学就业多方位上升通道",
    },
    {
      name: "讲练结合，互动教学",
      desc: "灵活互动教学，基础扎实，举一反三，查漏补缺",
    },
    {
      name: "统一管理，双向反馈",
      desc: "学习、生活统一管理，定期向家长反馈学生的学习情况",
    },
    {
      name: "四维管理，升学指导",
      desc: "学科规划，心理疏导，家庭教育，志愿填报",
    },
  ]
  const bottomList = [
    {
      name: "每日合理作息",
      desc: ["营养搭配", "适度锻炼", "互动课堂", "自习答疑", "沟通反馈"],
    },
    {
      name: "每周学习疏导",
      desc: ["学习情况评估", "1V1心理疏导", "每周集体班会", "内务检测评比"],
    },
    {
      name: "每月学情反馈",
      desc: ["月度家长沟通", "学习方案改进", "教学计划优化", "心理减压座谈"],
    },
  ]

  return (
    <section className={styles["teaching-container"]}>
      <h3 className="section__title">专业教学管理</h3>
      <div className="section__inner">
        <ul className={classnames("teaching-toplist", "clearfix")}>
          {topList.map((model) => {
            return (
              <li
                key={model.name}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <h4>{model.name}</h4>
                <p>{model.desc}</p>
              </li>
            )
          })}
        </ul>
        <ul className={classnames("teaching-bottomlist", "clearfix")}>
          {bottomList.map((model) => {
            return (
              <li
                key={model.desc}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <h4>{model.name}</h4>
                {model.desc.map((text) => (
                  <p key={text}>{text}</p>
                ))}
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Teaching
